var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5748 5.73105C10.8725 5.4334 11.3551 5.4334 11.6527 5.73105L17.7503 11.8286C18.0479 12.1263 18.0479 12.6089 17.7503 12.9065L11.6527 19.0041C11.3551 19.3017 10.8725 19.3017 10.5748 19.0041C10.2771 18.7064 10.2771 18.2238 10.5748 17.9262L16.1334 12.3676L10.5748 6.80896C10.2771 6.51131 10.2771 6.02871 10.5748 5.73105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.503 5.65877C10.8404 5.32143 11.3873 5.32143 11.7246 5.65877L17.8222 11.7563C18.1595 12.0937 18.1595 12.6406 17.8222 12.978L11.7246 19.0755C11.3873 19.4129 10.8404 19.4129 10.503 19.0755C10.1657 18.7382 10.1657 18.1912 10.503 17.8539L15.9898 12.3671L10.503 6.8804C10.1657 6.54305 10.1657 5.99611 10.503 5.65877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8b9c4ec141501ba1570a94bd076e6e4d.svg";
export { ForwardRef as ReactComponent };